// import React from "react";
// import { keyToTitle } from "../../../../../utils";
// import { InfoText } from "../../../../../components";

// const PersonalDetails = () => {
//   let personalDetails = [
//     {
//       "First Name": "David",
//       "Middle Name": "--",
//       "Last Name": "Mosure",
//       Gender: "--",
//       "Primary Email": "dmosure12@gmail.com",
//       State: "OH-US",
//       City: "Youngstown",
//       Zipcode: "28451",
//     },
//   ];
//   return (
//     <div className="grid grid-cols-3 gap-5 my-3 ">
//       {Object.entries(personalDetails[0]).map(([key, value]) => {
//         return (
//           <div className="mx-5 font-[500]">
//             <InfoText
//               size="sm"
//               key={key}
//               title={keyToTitle(key)}
//               value={value}
//             />
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default PersonalDetails;

import React from "react";
import { InfoText } from "../../../../../components";
import { formatWords2 } from "../../../../../utils/stringUtils";

const PersonalDetails = ({ applicant, origin }) => {
  // console.log("Selected Applicant:", applicant);

  if (!applicant) return <p className="text-gray-500">No applicant Details</p>;

  // const [firstName = "-", lastName = "-"] = applicant.applicantName
  //   ? applicant.applicantName.split(" ")
  // : ["-", "-"];
  // const genderMap = { 1: "Male", 2: "Female" };
  const genderMap = {
    1: "MALE",
    2: "FEMALE",
    3: "WISH NOT TO SPECIFY",
    4: "OTHER"
  }
  //console.log(applicant)

  const emailKey = applicant?.["Primary Email"] ? applicant?.["Primary Email"]?.email?.primary?.email || applicant?.["Primary Email"]?.email : applicant?.["Primary Email"] || "-"
  // console.log(emailKey)
  const newPersonalDetails = [
    {
      // "First Name": firstName,
      "First Name": formatWords2(applicant?.["First Name"] || "-"),
      "Last Name": formatWords2(applicant?.["Last Name"] || "-"),
      "Primary Email": emailKey ? emailKey : "-", //emailKey ? emailKey :
      Gender: genderMap[applicant?.["Gender"]] || "-",
      City: formatWords2(applicant?.["City"] || "-"),
      State: formatWords2(applicant?.["State"] || "-"),
      Zipcode: "-",
    },
  ];
  const loc = applicant?.location;
  const [country = "", state = "", city = ""] = typeof loc === "string" ? loc.split("-") : [];
  const name = applicant?.name;
  const [firstName = "", lastName = ""] = typeof name === "string" ? name.split(" ") : [];
  const personalDetails = [
    {
      // "First Name": firstName,
      "First Name": formatWords2(applicant?.firstName || firstName || "-"),
      "Last Name": formatWords2(applicant?.lastName || lastName || "-"),
      "Primary Email": applicant?.email?.primary?.email || "-",
      Gender: genderMap[applicant?.gender] || "-",
      City: formatWords2(applicant?.location?.city || city || "-"),
      State: formatWords2(applicant?.location?.state?.name || applicant?.location?.state || state || "-"),
      Zipcode: applicant?.location?.zipCode || "-",
    },
  ];
  const data = origin == "resumeViewer" ? newPersonalDetails[0] : personalDetails[0]
  // console.log(data[0] || data)
  // console.log(personalDetails[0])

  return (
    <div className="grid grid-cols-3 gap-5 my-3">
      {Object.entries(data || []).map(([key, value]) => (
        <div className="mx-5 font-[500]" key={key}>
          <InfoText size="sm" title={key} value={value} />
        </div>
      ))}
    </div>
  );
};

export default PersonalDetails;
